<template>
  <div class='add-funding-overlay'>
    <p class="small">Your request will be sent to your card administrator for approval.</p>
    <label>Current Balance</label>
    <br />
    <v-money class="small" currency="USD" locale="en">{{balance}}</v-money>
    <br />
    <br />
    <label>Funding Amount</label>
    <ed-input type='money' amount v-model='fundingAmount' :error='addFundsError' @input="(value) => $emit('fundingAmount', value)">
      <div slot="message" v-if="addFundsError">
        {{ errorMessage }}:
        <strong>
          <v-money>{{balance}}</v-money>
        </strong>
      </div>
    </ed-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fundingAmount: '',
      errorMessage: 'The amount cannot be greater than the current balance'
    }
  },
  props: {
    balance: 0,
    addFundsError: Boolean
  }
}
</script>

<style lang='scss' scoped>

  .add-funding-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardAddFunds.vue